import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { result } from 'lodash';
import { Subscription } from 'rxjs';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { CommonService } from 'src/app/Service/Common.service';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { DocumentService } from 'src/app/Service/document/document.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { RestApiService } from 'src/app/Service/rest-api.service';
import { IDocumentMailOutputModel } from 'src/app/ViewModel/DocumentModel';

@Component({
  selector: 'app-attachments-list',
  templateUrl: './attachments-list.component.html',
  styleUrls: ['./attachments-list.component.css']
})
export class AttachmentsListComponent implements OnInit,OnDestroy {
  public messageId!: number;
  public documentList: any[] = [];
  public messageList: any[] = [];
  public Category: any;
  public mailsection: boolean = false;
  public attachment: boolean = true;
  public docNo: string = '';
  public mailList: IDocumentMailOutputModel[] = [];
  public filteredList: IDocumentMailOutputModel[] = [];
  public findMailList: any = {};
  public selectedMailType: number = 0;
  public show : boolean = false;
  UnsubscribeArray:Subscription[]=[];

  constructor(

    public restApiService: RestApiService,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public commonService: CommonService,
    private _docService: DocumentService,
    public notificationService: NotificationService,
    public dialogRef: MatDialogRef<AttachmentsListComponent>,
    private communicationService: CommunicationService,
  ) { }
  ngOnInit() {
    this.messageId = this.data["messageId"];
    this.getMessageList();
    this.getDocumentList();
  }
  public togglePopupDialog() {
    this.dialogRef.close();
  }
  /**
   * Data Binding in Grid
   * @param type
   *
   */
  public getMessageList() {
    let _getMessageAttachmentsList=this.communicationService.getMessageAttachmentsList(this.messageId).subscribe((data: any[]) => {
      this.data = data.map(x => {
        let result: any = {
          messageId: x.messageId,
          attachedMessageId: x.attachedMessageId,
        };
        return result;
      });
      return result;
    });
    this.UnsubscribeArray.push(_getMessageAttachmentsList)
  }

  /**
   * Data Binding in Grid
   * @param type
   *
   */

  viewMessageList(Category: number, Val: any) {
    this.Category = Category;
    this.docNo = Val.documentNo;
    this.findMailList = Val;
    this.selectedMailType = this.Category;
    this.getMailListtoDp()
  }

  async getMailListtoDp() {
    let TransType = "";
    this.mailList = await this._docService.getDocumentMsgList(this.findMailList.docId, this.commonService.getProjectId(),
      this.commonService.getLoggedInUserGroupId(), this.commonService.getLoggedInUserId(), TransType, null).toPromise();
    if (!!this.mailList) {
      this.mailsection = true;
      this.attachment = false;
      if (this.Category == 2) {
        this.filteredList = this.mailList.filter(x => x.messageCategory == 3);  
        this.show = false;    
      }
      else {
        this.filteredList = this.mailList.filter(x => x.messageCategory != 3);
        this.show = true;
      }
    }
  }

  filterMailType(event: any) {
    if (event.value == 2) {
      this.filteredList = this.mailList.filter(x => x.messageCategory == 3);
      this.show = false;
    }
    else {
      this.filteredList = this.mailList.filter(x => x.messageCategory != 3);
      this.show = true;
    }
  }

  ViewMail(Val: any) {
    this.dialogRef.close(Val);
  }

  getSubAttachment(Val: any) {
    this.mailsection = false;
    this.attachment = false;
    let canEdit: boolean = false;
    const dialogRef = this.dialog.open(FileListComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '70%',
      data: { projectId: this.commonService.getProjectId(), docId: Val.docId, revisionNo: Val.revision, moduleName: 'EDMS', libraryName: 'Documents', createdBy: this.commonService.getLoggedInUserId(), isDeleteEnable: canEdit, documentNo: this.docNo },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.dialogRef.close();
    });
  }
  
  public getDocumentList() {
   let _getMessageDocumentsList=this.communicationService.getMessageDocumentsList(this.messageId).subscribe((data: any[]) => {
      this.data = data.map(x => {
        let result: any = {
          messageId: x.messageId,
          docId: x.docId,
          documentNo: x.documentNo,
          title: x.title,
          revision: x.revision,
          revisedOn: x.revisedOn,
          createdBy: x.createdBy,
          authorisedBy: x.authorisedBy
        };
        return result;
      });
      this.documentList = this.data;
      return result;
    });
    this.UnsubscribeArray.push(_getMessageDocumentsList)
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy()
  {
    this.UnsubscribeArray.forEach(x => x.unsubscribe())
  }

}
